import { j as a, a as l } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { IonItem as m } from "@ionic/react";
import { I as _ } from "../../../Icon-CAQ-6E_J.js";
import "../../../FeatureFlagProvider-DyczYY1y.js";
import "react";
import "../../../react-paginate-Lh5zQzpz.js";
import "../../organisms/LoadingInterstitial/LoadingInterstitial.js";
import "../../contexts/DesignSystemProvider/DesignSystemProvider.js";
import '../../../css/DataItemView.css';const g = "_icon_1oty5_55", y = "_label_1oty5_59", p = "_children_1oty5_71", i = {
  "data-item": "_data-item_1oty5_1",
  "data-grid-icon": "_data-grid-icon_1oty5_6",
  "data-grid-icon-stacked": "_data-grid-icon-stacked_1oty5_22",
  "data-grid-no-icon": "_data-grid-no-icon_1oty5_30",
  "data-grid-no-icon-stacked": "_data-grid-no-icon-stacked_1oty5_47",
  icon: g,
  label: y,
  children: p
};
function $(n) {
  const {
    icon: o,
    iconColor: d,
    label: c,
    lines: e,
    stackLayout: t,
    children: r,
    style: s
  } = n;
  return /* @__PURE__ */ a(m, {
    lines: e || "none",
    className: `${i["data-item"]} ion-no-padding`,
    style: {
      ...s
    },
    children: /* @__PURE__ */ l("div", {
      className: `${o ? i["data-grid-icon"] : i["data-grid-no-icon"]} ${t && o ? i["data-grid-icon-stacked"] : t && !o ? i["data-grid-no-icon-stacked"] : ""}`,
      children: [o && /* @__PURE__ */ a("div", {
        className: `${i.icon}`,
        children: /* @__PURE__ */ a(_, {
          name: o,
          color: d
        })
      }), /* @__PURE__ */ a("div", {
        className: i.label,
        style: {
          gridColumnStart: o ? 2 : void 0,
          gridColumn: t ? "span 2" : void 0
        },
        children: c
      }), /* @__PURE__ */ a("div", {
        className: i.children,
        children: r
      })]
    })
  });
}
export {
  $ as DataItemView
};
